var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_vm._t("default",null,{"show":_vm.show,"openedByCookie":_vm.openedByCookie,"open":_vm.open,"close":_vm.close,"toggle":_vm.toggle})],2)}
var staticRenderFns = []

export { render, staticRenderFns }